import { Info } from 'lucide-react';

interface InfoTooltipProps {
  label: any;
  content: string;
}

const InfoTooltip = (props: InfoTooltipProps) => {
  const { label, content } = props;

  return (
    <span className="inline-flex items-center gap-2">
      <span>{label}</span>
      <span className="group/tooltip relative inline-flex items-center">
        <button
          type="button"
          tabIndex={0}
          aria-label={`More information about ${typeof label === 'string' ? label : 'this field'}`}
          className="inline-flex h-4 w-4 items-center justify-center rounded-full text-slate-500 transition-colors hover:text-emerald-300 focus:outline-none focus:ring-2 focus:ring-emerald-500/40 focus:text-emerald-300"
        >
          <Info size={12} />
        </button>
        <span className="pointer-events-none absolute left-1/2 top-full z-30 mt-2 w-64 -translate-x-1/2 rounded-2xl border border-slate-700 bg-slate-950 px-3 py-2 text-[11px] normal-case tracking-normal text-slate-200 opacity-0 shadow-2xl shadow-black/40 transition-all duration-150 group-hover/tooltip:translate-y-0 group-hover/tooltip:opacity-100 group-focus-within/tooltip:translate-y-0 group-focus-within/tooltip:opacity-100">
          {content}
        </span>
      </span>
    </span>
  );
};

export default InfoTooltip;
